
export const FETCH_BILL_RECEIVING_REPORT_DATA_REQUEST = 'FETCH_BILL_RECEIVING_REPORT_DATA_REQUEST';
export const FETCH_BILL_RECEIVING_REPORT_DATA_SUCCESS = 'FETCH_BILL_RECEIVING_REPORT_DATA_SUCCESS';
export const FETCH_BILL_RECEIVING_REPORT_DATA_FAILURE = 'FETCH_BILL_RECEIVING_REPORT_DATA_FAILURE';


export const VERIFY_BILL_RECEIVING_REPORT_DATA_REQUEST = 'VERIFY_BILL_RECEIVING_REPORT_DATA_REQUEST';
export const VERIFY_BILL_RECEIVING_REPORT_DATA_SUCCESS = 'VERIFY_BILL_RECEIVING_REPORT_DATA_SUCCESS';
export const VERIFY_BILL_RECEIVING_REPORT_DATA_FAILURE = 'VERIFY_BILL_RECEIVING_REPORT_DATA_FAILURE';

export const CREATE_USERFORM_BILL_RECEIVING_REPORT = 'CREATE_USERFORM_BILL_RECEIVING_REPORT';

export const SET_RENDER_TAB_DATA = 'SET_RENDER_TAB_DATA';

export const FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_REQUEST = 'FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_REQUEST';
export const FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_SUCCESS = 'FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_SUCCESS';
export const FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_FAILURE = 'FETCH_BILL_RECEIVING_REPORT_CONSOLIDATE_DATA_FAILURE';